import { FicheMark } from "./FicheMark";
import { FicheShareLine } from "./share";
import { ContactsButton, FeedButton, StatusPills } from "./Suivi";
import type { RelationStatus } from "./suivi";
import type { CrmFiche } from "./types";
import { identityLine } from "./ficheIdentity";

export function FicheHead({ fiche, tone, onShare }: { fiche: CrmFiche; tone?: RelationStatus; onShare: (fiche: CrmFiche) => void }) {
  const city = [fiche.postal_code, fiche.city].filter(Boolean).join(" ");
  const place = [fiche.address, city].filter(Boolean).join(", ");
  const phone = formatPhone(fiche.phone);
  const who = [fiche.email, phone].filter(Boolean).join("  ·  ");
  const folder = fiche.coffre_path || "Dossier Coffre";

  return (
    <div className="flex flex-wrap items-start gap-x-5 gap-y-3 px-6 pt-6">
      <FicheMark path={fiche.logo_path} name={fiche.name} tone={tone} className="h-16 w-16 shrink-0 text-lg" />
      <div className="min-w-[12rem] flex-1 space-y-0.5">
        <div className="flex min-w-0 items-baseline gap-3">
          <h1 className="crm-title truncate text-2xl font-semibold tracking-tight">{fiche.name}</h1>
          <span className="shrink-0 text-xs font-semibold tracking-[0.14em] text-slate-400">{fiche.code}</span>
        </div>
        {place ? <p className="truncate text-sm leading-snug text-slate-600">{place}</p> : null}
        <p className="truncate text-sm leading-snug text-slate-600">{who || "Aucun contact sur la fiche"}</p>
        <p className="truncate text-sm leading-snug text-slate-600">{identityLine(fiche)}</p>
        {fiche.tags?.length > 0 ? <p className="truncate text-xs leading-snug text-slate-500">{fiche.tags.join(" · ")}</p> : null}
        <p className="truncate text-sm leading-snug text-slate-500">Coffre · {folder}</p>
      </div>
      <div className="ml-auto flex w-full min-w-[16rem] max-w-xl flex-col items-end gap-2 sm:w-auto">
        <FicheShareLine fiche={fiche} onChange={onShare} />
        <div className="flex flex-wrap items-center justify-end gap-2">
          <StatusPills />
          <FeedButton folder={fiche.coffre_path} ownerId={fiche.coffre_owner_id || 0} />
          <ContactsButton fiche={fiche} />
        </div>
      </div>
    </div>
  );
}

function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10) return value.trim();
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
}
